import * as React from 'react';
import './toolbox.css';

interface ToolBoxProps {
  onToolClick: (tool: string) => void;
  activeTool?: string;
  tools?: string[];
  className?: string;
}

const ToolBox: React.FC<ToolBoxProps> = ({ 
  onToolClick, 
  activeTool = '', 
  tools = ['mirror', 'protractor', 'ruler', 'drag', 'crop', 'point', 'vertical', 'horizontal', 'verticalAngle', 'horizontalAngle'],
  className = ''
}) => {
  // 默认工具图标映射
  const toolIcons = {
    mirror: '🔄',
    protractor: '📐',
    ruler: '📏',
    drag: '✋',
    crop: '✂️',
    point: '📍',
    vertical: '↕️',
    horizontal: '↔️',
    verticalAngle: '⦜',
    horizontalAngle: '∟'
  };

  // 默认工具提示映射
  const toolTips = {
    mirror: '镜像',
    protractor: '量角器',
    ruler: '直尺',
    drag: '拖拽',
    crop: '裁剪',
    point: '标记点',
    vertical: '垂直线',
    horizontal: '水平线',
    verticalAngle: '垂直角度',
    horizontalAngle: '水平角度'
  };

  return (
    <div className={`tool-box ${className}`}>
      {tools.map((tool) => (
        <button
          key={tool}
          className={`tool-btn ${activeTool === tool ? 'active' : ''}`}
          onClick={() => onToolClick(tool)}
          title={toolTips[tool] || tool}
        >
          <span className="tool-icon">{toolIcons[tool] || '工具'}</span>
        </button>
      ))}
    </div>
  );
};

export default ToolBox;